import { useStorage } from "./useStorage";

export function useLocalStorage<T>(
  key: string,
): [T | null, (v: T) => void, { isLoading: boolean }] {
  return useStorage<T>(key, "local");
}
